import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, ButtonGroup, Dropdown, DropdownButton, Form, Modal } from 'react-bootstrap';
import Container from '../components/Container';
import ErrorComponent from '../components/ErrorComponent';
import MaskedInput from '../components/MaskedInput';
import PageComponent from '../components/PageComponent';
import Connection from '../config/Connection';
import Labels from '../Labels';
import '../styles/generics.css';
import GenericHelper from '../Tools/GenericHelper';
import Parsers from '../Tools/Parsers';
import ProgramGoalQAwardPage from './ProgramGoalQAwardPage';
import './ProgramNewPage.css';


const defaultInvoice = {
  accountAgency: "",
  accountBank: "",
  accountNumber: "",
  accountType: "",
  criticalValue: null,
  datetimeEmission: null,
  indentificator: null,
  issuer: null,
  kind: null,
  series: null,
  title: null,
  valueTotal: null,
  invoiceType: null,
  mainKeyCriticalType: null
};

export default class ProgramGoalRefundPage extends PageComponent {
  static PageInfo = {
    path: "/Program/Detail/:id/Goal/:goal/ActionPlan/:action/Invoice/:invoice",
    parent: ProgramGoalQAwardPage,
    name: "menu.programrefund",
    permission: { "INVOICE_ACCESSING": true },
    icon: "dollar-sign",
    hidden: true
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.loading = true;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.costumerLoading = false;
    this.state.isModalVisible = null;
    this.state.modalError = null;
    this.state.selectedType = null;
    this.state.selectedBrand = null;
    this.state.changed = false;
    this.state.label = null;
    this.state.goal = null;
    this.state.selectionType = "name";
    this.state.filter = "";
    this.state.doc = null;
    this.state.region = null;
    this.state.city = null;
    this.state.name = null;
    this.state.selectedClient = null;
    this.state.form = null;
    this.state.tabmode = "home";
    this.state.hierarchy = null;
    this.state.productGroupDevolutionId = null;
    this.state.fkClientType = null;
    this.state.datetimeRegister = null;
    this.state.promotionalBudgetTypeId = null;
  }

  componentDidMount() {
    this.searchDataForScreen();

  }

  searchDataForScreen() {

    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/Action/" + this.data.action + "/Refund/" + this.data.invoice)
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false, status: data.qaApInvoiceStatusElement[0] }));
            //console.log(data)
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  getNext() {
    switch (this.state.data.status.programStatus.keyConstant) {
      case 11:
        return 10
    }
    return 0;
  }

  checkForm(target) {
    for (var i in target)
      if (target[i] == null) return false;
    return true;
  }
  updateForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  openModal(target, props) {
    var v = {};
    props = typeof props === "object" && props != null ? props : {};
    props.isModalVisible = target;
    props.modalInitializing = false;
    props.file = null;
    props.modalLoading = false;
    props.form = {}
    props.modalError = null;
    this.setState(props);
  }

  deleteItem() {
    var item = this.state.selectedItem;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal + "/Award/Action/" + this.data.action + "/Invoice/" + this.data.invoice + "/File/" + this.state.selectedItem.storageManager.keyConstant,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          try {
            this.state.data.invoice.storageInvoiceElement.splice(this.state.data.invoice.storageInvoiceElement.indexOf(item), 1);
          } catch (e) { }
          this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  deleteInvoice() {
    var item = this.state.selectedItem;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal + "/Award/Action/" + this.data.action + "/Invoice/" + this.data.invoice,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          this.props.history.replace("/Program/Detail/" + this.data.id + "/Goal/" + this.data.goal + "/QualitativeAward");
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  editInvoice() {
    this.setState({ modalLoading: true });

    var d = JSON.parse(JSON.stringify(this.state.form));

    d.storageInvoiceElement = [{ observation: d.observation }];
    delete d.observation;

    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal + "/Award/Action/" + this.data.action + '/Invoice/' + this.data.invoice,
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(d)
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(st => {
            this.state.data.qaActionPlan.valueUsed = this.state.data.qaActionPlan.valueUsed - this.state.data.invoice.valueTotal + this.state.form.valueTotal;
            GenericHelper.copyProperties(this.state.form, this.state.data.invoice);
            this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant == 1)[0].storageManager.observation = this.state.form.observation;
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data, status: st });
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  addNewFile() {
    this.setState({ modalLoading: true });

    var data = new FormData();
    this.state.form.keyConstant = this.state.selectedType;

    data.append('data', JSON.stringify(this.state.form));
    data.append('target', this.data.action);
    data.append('file', this.state.file);
    data.append('observation', this.state.observation);

    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal + "/Award/Action/" + this.data.action + "/Invoice/" + this.data.invoice + "/File",
      {
        "method": "POST",
        body: data
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => {
            this.state.data.invoice.storageInvoiceElement.push(t);
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
            this.searchDataForScreen()
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  parseDate(t) {
    t = t.split('/');
    return t[2] + "-" + t[1] + "-" + t[0] + "T00:00:00";
  }


  changeStatus() {
    this.setState({ modalLoading: true });

    var data = new FormData();

    data.append('data', JSON.stringify({ programStatus: { keyConstant: this.state.nextstatus }, observation: typeof this.state.form.observation === "string" ? this.state.form.observation : null }));
    // data.append('target', this.data.action);

    if (this.state.file != null) {
      data.append('file', this.state.file.files[0]);
      data.append('target', 5);
    }

    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" +
      this.data.goal + "/Award/Action/" + this.data.action + "/Refund/" + this.data.invoice + "/Status",
      {
        "method": "PUT",
        body: data
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => {
            try {
              for (let i = 0; i < t.qaActionPlanInvoice.invoice.storageInvoiceElement.length; i++) {
                const element = t.qaActionPlanInvoice.invoice.storageInvoiceElement[i];
                this.state.data.invoice.storageInvoiceElement.push(element);
              }
            } catch (e) {
            }
            this.setState({ modalLoading: false, isModalVisible: null, status: t });
          });

        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  renderFile(item2, fixed, title) {
    return <a target="_blank" href={Connection.service + "Program/" + this.data.id + "/Client/" + this.data.goal + "/File/" + item2.storageManager.keyConstant + "/" + item2.storageManager.filename} className="generics_listing_item">
      <FontAwesomeIcon icon="file" className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{typeof title === "string" ? title : item2.storageManager.value}</div>
        <div className="generics_listing_item_description" >{item2.storageManager.observation}</div>
        <div className="generics_listing_item_description" style={{ textAlign: "right", fontWeight: "bold" }} >{item2.storageManager.filename}</div>
        <div className="generics_listing_item_description" style={{ textAlign: "right" }} >{Parsers.parseDate(item2.storageManager.datetimeRegister)}</div>
      </div>
      {
        fixed == true || !(this.state.status.programStatus.keyConstant == 1 || this.state.status.programStatus.keyConstant == 2 || this.state.status.programStatus.keyConstant == 9) ? null :
          <div className="generics_listing_item_action" onClick={(e) => { this.setState({ isModalVisible: "delete", modalLoading: false, selectedItem: item2 }); return GenericHelper.cancelBubble(e); }}><FontAwesomeIcon icon="times" /></div>
      }
    </a>;
  }

  handleFileChange = (target, fileKey) => {
    const fileCheck = target.files[0];
    if (fileCheck) {

      const fileProperties = this.state.data.invoice.storageInvoiceElement.map(existingFile =>
        existingFile.storageManager && ({
          name: existingFile.storageManager.filename,
          type: existingFile.storageManager.filetype
        }));

      const fileToCheck = {
        name: fileCheck.name,
        type: fileCheck.type
      };

      if (fileProperties.some(existingFile => JSON.stringify(existingFile) === JSON.stringify(fileToCheck))) {
        this.setState({ [fileKey]: null, errorFiles: Labels.GetLabel("program_refund.filenot3") });
      } else {
        this.setState({ [fileKey]: fileCheck, errorFiles: null });
      }
    }
  };

  render() {
    return (
      <Container context={this.constructor}>

        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
              <div className="generics_panels" style={{ flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {Labels.GetLabel(this.constructor.PageInfo.name)} </span>
                    <div style={{ fontSize: 25 }}>{this.state.data.invoice.title}</div></div>

                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(this.state.status.programStatus.keyConstant, "invoice") }}>
                    <div className="generics_status_bar_title">
                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(this.state.status.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />
                      {Labels.GetLabel("STATUS_PROGRAM_REFUND." + this.state.status.programStatus.keyConstant)}
                    </div>
                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.status.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(this.state.status.datetimeRegister, "time")})</div>
                    <div className="generics_status_bar_desc">{Labels.GetLabel("REFUND_STATUS_PROGRAM_DESC." + this.state.status.programStatus.keyConstant)}</div>
                    {typeof this.state.status.observation === "string" && this.state.status.observation.length > 0 ?
                      <div className="generics_status_bar_desc">
                        <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel("generic.observation")}:</div>
                        {this.state.status.observation}
                      </div>
                      : null}

                    {
                      Parsers.parsePermission2(["INVOICE_APPROVE", "INVOICE_DECLINE"]) && this.state.status.programStatus.keyConstant == 11 ?

                        <div style={{ textAlign: "right", marginTop: 20 }}>
                          <Button variant="danger" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 9 })}>
                            {Labels.GetLabel("REFUND_STATUS_PROGRAM_ACTION_B." + this.state.status.programStatus.keyConstant)}
                          </Button>
                          <Button variant="success"
                            disabled={this.state.changed} style={{ marginRight: 10 }}
                            onClick={() => this.openModal("changestatus", { nextstatus: 10 })}
                          >
                            {Labels.GetLabel("REFUND_STATUS_PROGRAM_ACTION_A." + this.state.status.programStatus.keyConstant)}
                          </Button>
                        </div>
                        :
                        Parsers.parsePermission2(["INVOICE_CREATION", "INVOICE_EDIT"]) && (this.state.status.programStatus.keyConstant == 1 || this.state.status.programStatus.keyConstant == 2) ?

                          <div style={{ textAlign: "right", marginTop: 20 }}>
                            <Button variant="success"
                              disabled={!this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant != 1 && t.storageInvoiceElType.keyConstant != 5).length >= 2}
                              style={{ marginRight: 10 }}
                              onClick={() => this.openModal("changestatus", { nextstatus: 11 })}
                            >
                              {Labels.GetLabel("REFUND_STATUS_PROGRAM_ACTION_A." + this.state.status.programStatus.keyConstant)}
                            </Button>
                          </div>
                          :
                          Parsers.parsePermission2(["INVOICE_PAYMENT"]) && this.state.status.programStatus.keyConstant == 10 ?

                            <div style={{ textAlign: "right", marginTop: 20 }}>
                              <Button variant="success"
                                disabled={this.state.changed}
                                style={{ marginRight: 10 }}
                                onClick={() => this.openModal("changestatus", { nextstatus: 12 })}
                              >
                                {Labels.GetLabel("REFUND_STATUS_PROGRAM_ACTION_A.12")}`
                              </Button>
                            </div>
                            : null
                    }

                  </div>

                  <div style={{ padding: 20 }}>
                    <div className="generic_section_header">{Labels.GetLabel("generic.details")} </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.invoicevalue")}</div>
                      <div className="generics_infobox_value" style={{ fontSize: 25 }}>{Parsers.parseMoney(this.state.data.invoice.valueTotal)}</div>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.InvoiceType")}</div>
                      <div className="generics_infobox_value">{Labels.GetLabel("invoice_type." + this.state.data.invoice.invoiceType.keyRegister)}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.Indentificator")}</div>
                      <div className="generics_infobox_value">{this.state.data.invoice.indentificator}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.MainKeyCriticalType")}</div>
                      <div className="generics_infobox_value">{Labels.GetLabel("DOC_TYPE." + this.state.data.invoice.mainKeyCriticalType.keyConstant)}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.criticalValue")}</div>
                      <div className="generics_infobox_value">{this.state.data.invoice.criticalValue}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.DatetimeEmission")}</div>
                      <div className="generics_infobox_value">{Parsers.parseDate(this.state.data.invoice.datetimeEmission, "time")}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.Issuer")}</div>
                      <div className="generics_infobox_value">{this.state.data.invoice.issuer}</div>
                    </div>
                    {/* <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.Kind")}</div>
                      <div className="generics_infobox_value">{this.state.data.invoice.kind}</div>
                    </div> */}
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.Series")}</div>
                      <div className="generics_infobox_value">{this.state.data.invoice.series}</div>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    {
                      this.state.data.invoice.accountAgency != null &&
                        this.state.data.invoice.accountBank != null &&
                        this.state.data.invoice.accountNumber != null &&
                        this.state.data.invoice.accountType != null ?
                        <div>
                          <div className="generic_section_header">{Labels.GetLabel("program_refund.refundinfo")}</div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("program_refund.accountAgency")}</div>
                            <div className="generics_infobox_value">{this.state.data.invoice.accountAgency}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("program_refund.accountBank")}</div>
                            <div className="generics_infobox_value">{this.state.data.invoice.accountBank}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("program_refund.accountNumber")}</div>
                            <div className="generics_infobox_value">{this.state.data.invoice.accountNumber}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("program_refund.accountType")}</div>
                            <div className="generics_infobox_value">{this.state.data.invoice.accountType}</div>
                          </div>
                          <div style={{ clear: "both" }}></div>
                        </div> : null
                    }
                    <div className="generic_section_header"></div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program.program")}</div>
                      <div className="generics_infobox_value">{this.state.data.qaActionPlan.qualitativeAward.purchasingGoal.program.label}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("generic.brand")}</div>
                      <div className="generics_infobox_value">{this.state.data.qaActionPlan.qualitativeAward.purchasingGoal.program.brand.label}</div>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program.prize")}</div>
                      <div className="generics_infobox_value">{this.state.data.qaActionPlan.label}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.unity")}</div>
                      <div className="generics_infobox_value">{Parsers.parseNumber(this.state.data.qaActionPlan.amount)}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.unityvalue")}</div>
                      <div className="generics_infobox_value">{this.state.data.qaActionPlan.valueUnitary}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.ValueTotal")}</div>
                      <div className="generics_infobox_value">{Parsers.parseMoney(this.state.data.qaActionPlan.valueTotal)}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.usedvalue")}</div>
                      <div className="generics_infobox_value">{Parsers.parseMoney(this.state.data.qaActionPlan.valueUsed)}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.actiondate")}</div>
                      <div className="generics_infobox_value">{Parsers.parseDate(this.state.data.qaActionPlan.dateEvent, "time")}</div>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <br />
                    {(t => {
                      var v = this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant == 5);
                      return v.length == 0 ? null : <div><div className="generic_section_header">{Labels.GetLabel("program_refund_type.5")}</div>
                        {
                          v.map((item2) => this.renderFile(item2, undefined, Labels.GetLabel("program_refund_type.5")))
                        }
                      </div>
                    })()}
                    <br />
                    {(t => {
                      var v = this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant == 1);
                      return <div><div className="generic_section_header">{Labels.GetLabel("program_refund_type.1")} </div>
                        {
                          v.map((item2) => this.renderFile(item2, true))
                        }
                      </div>
                    })()}
                    <br />
                    {(t => {
                      var v = this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant != 1 && t.storageInvoiceElType.keyConstant != 5);
                      return <div><div className="generic_section_header">{Labels.GetLabel("program_refund_type.2")}
                        {
                          !(this.state.status.programStatus.keyConstant == 1 || this.state.status.programStatus.keyConstant == 2 || this.state.status.programStatus.keyConstant == 9) || !Parsers.parsePermission2(["INVOICE_EDIT", "INVOICE_CREATION"]) ? null :
                            <div className="generic_section_header_action" onClick={() => this.openModal("file", { "selectedType": 2 })}><FontAwesomeIcon icon="plus" /></div>
                        }</div>
                        {
                          v.length == 0 ?
                            <div className="generics_missing_info">
                              <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel('program_refund.requiredtitle')}</div>
                              <div>{Labels.GetLabel('program_refund.required')}</div>
                            </div> :
                            v.map((item2) => this.renderFile(item2))
                        }
                      </div>
                    })()}
                    <br />
                    <br />
                  </div>
                </div>
                <div style={{ bottom: -10, position: "sticky", display: "flex", flexDirection: "row", backgroundColor: "#ffffff", margin: -10, padding: 10, borderTop: "1px solid rgb(240, 240, 240)" }}>

                  {!Parsers.parsePermission2(["INVOICE_EDIT"]) ? null :
                    <DropdownButton disabled={this.state.changed}
                      as={ButtonGroup}
                      key="up"
                      drop="up"
                      variant="primary" style={{ marginRight: 10 }}
                      title={Labels.GetLabel("program.edit")}
                      onSelect={(t) => this.openModal(t)}
                    >
                      {this.state.status.programStatus.keyConstant == 1 || this.state.status.programStatus.keyConstant == 2 || this.state.status.programStatus.keyConstant == 9 ?
                        <Dropdown.Item eventKey="deleteinvoice">{Labels.GetLabel("program.deleteinvoice")}</Dropdown.Item>
                        : null
                      }
                      {this.state.status.programStatus.keyConstant == 1 || this.state.status.programStatus.keyConstant == 2 || this.state.status.programStatus.keyConstant == 9 ?
                        <Dropdown.Item eventKey="edit">{Labels.GetLabel("myuser.edit")}</Dropdown.Item>
                        : null
                      }
                    </DropdownButton>
                  }
                  <Button variant="primary" style={{ marginRight: 10 }} onClick={() => this.openModal("history")}>
                    {Labels.GetLabel("generic.history")}
                  </Button>
                  <div style={{ flex: 1 }}></div>
                  <div style={{ clear: "both" }}></div>
                </div>
                <Modal
                  className={this.state.modalLoading == true ? "modal-loading" : ""}
                  onHide={() => { }} show={this.state.isModalVisible != null} >
                  <div>
                    {
                      this.state.modalInitializing == true || this.state.data == null || this.state.isModalVisible == null ?
                        <div>
                          {Labels.GetLabel("adminstategroup.saving")}
                        </div>
                        : this.state.isModalVisible == "history" ?
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("generic.history")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              {
                                this.state.data.qaApInvoiceStatusElement.map(t =>
                                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(t.programStatus.keyConstant, "invoice") }}>
                                    <div className="generics_status_bar_title">
                                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(t.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />{Labels.GetLabel("STATUS_PROGRAM_REFUND." + t.programStatus.keyConstant)}
                                    </div>
                                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(t.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(t.datetimeRegister)})</div>
                                  </div>)
                              }
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("adminstategroup.closebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div>
                          :
                          this.state.isModalVisible == "deleteinvoice" ?
                            <div>
                              <Modal.Header>
                                <Modal.Title>{Labels.GetLabel("program.deleteinvoice")}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                {Labels.GetLabel("generic.confirmdel")}
                                <br />
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                </Button>
                                <Button variant="primary" onClick={() => this.deleteInvoice()}>
                                  {Labels.GetLabel("generic.confirm")}
                                </Button>
                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                            </div>
                            :
                            this.state.isModalVisible == "delete" ?
                              <div>
                                <Modal.Header>
                                  <Modal.Title>{Labels.GetLabel("generic.delete")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  {Labels.GetLabel("generic.confirmdel")}
                                  <br />
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                    {Labels.GetLabel("adminstategroup.closebtn")}
                                  </Button>
                                  <Button variant="primary" onClick={() => this.deleteItem()}>
                                    {Labels.GetLabel("generic.confirm")}
                                  </Button>
                                </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                              </div>
                              :
                              this.state.isModalVisible == "goal" ?
                                <div>
                                  <Modal.Header>
                                    <Modal.Title>{Labels.GetLabel("program.programgoal")}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <MaskedInput type="int" notnull={true} label={"Meta"} value={"" + this.state.data.purchasingGoal.goal} onValid={(value) => this.setState({ goal: value })}
                                      onInvalid={(value) => this.setState({ goal: null })} />
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                      {Labels.GetLabel("adminstategroup.closebtn")}
                                    </Button>
                                    <Button variant="primary" disable={this.state.goal == null} onClick={() => this.saveGoal(this.state.goal)}>
                                      {Labels.GetLabel("adminstategroup.savebtn")}
                                    </Button>
                                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                </div>
                                :
                                this.state.isModalVisible == "actionplan" ?
                                  <div>
                                    <Modal.Header>
                                      <Modal.Title>{Labels.GetLabel("program.actionplan")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <MaskedInput type="text" notnull={true} label={"Ação"} onValid={(value) => this.updateForm("label", value)}
                                        onInvalid={(value) => this.updateForm("label", null)} />
                                      <MaskedInput type="int" notnull={true} label={"Quantidade"} onValid={(value) => this.updateForm("amount", parseInt(value))}
                                        onInvalid={(value) => this.updateForm("amount", null)} />
                                      <MaskedInput type="int" notnull={true} label={"Valor Unitário"} onValid={(value) => this.updateForm("valueUnitary", parseInt(value))}
                                        onInvalid={(value) => this.updateForm("valueUnitary", null)} />
                                      <MaskedInput type="date" notnull={true} label={"Data do Evento"} onValid={(value) => this.updateForm("dateEvent", this.parseDate(value))}
                                        onInvalid={(value) => this.updateForm("dateEvent", null)} />
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                        {Labels.GetLabel("adminstategroup.closebtn")}
                                      </Button>
                                      <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.addActionPlan(this.state.form)}>
                                        {Labels.GetLabel("adminstategroup.savebtn")}
                                      </Button>
                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                  </div>
                                  :
                                  this.state.isModalVisible == "award" ?
                                    <div>
                                      <Modal.Header>
                                        <Modal.Title>{Labels.GetLabel("program.qualitativeaward")}</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        {this.state.qualitativeAward != null ? Labels.GetLabel("programgoal.removeaward") : Labels.GetLabel("programgoal.newaward")}
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                          {Labels.GetLabel("adminstategroup.closebtn")}
                                        </Button>
                                        <Button variant="primary" onClick={() => this.state.qualitativeAward != null ? this.RemoveAwardProgram() : this.includeInProgram()}>
                                          {Labels.GetLabel("adminstategroup.savebtn")}
                                        </Button>
                                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                    </div>
                                    : this.state.isModalVisible == "file" ?
                                      <div>
                                        <Modal.Header>
                                          <Modal.Title>{Labels.GetLabel("program_refund_type." + this.state.selectedType)}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("label", value)} label={Labels.GetLabel("generic.filename")}
                                            onInvalid={(value) => this.updateForm("label", null)} />
                                          <Form.Label>{Labels.GetLabel("generic.file")}</Form.Label>
                                          <Form.File id="exampleFormControlFile" onChange={t => this.handleFileChange(t.target, 'file')} />
                                          {this.state.errorFiles && <p style={{ color: "red" }}>{this.state.errorFiles}</p>}
                                          <br />
                                          <MaskedInput type="text" onValid={(value) => this.setState({ observation: value })} label={Labels.GetLabel("program_refund.Obs")}
                                            onInvalid={(value) => this.setState({ observation: null })} />
                                        </Modal.Body>
                                        <Modal.Footer>
                                          <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                            {Labels.GetLabel("adminstategroup.closebtn")}
                                          </Button>
                                          <Button variant="primary"
                                            disabled={this.state.selectedType == null || this.state.observation == null || this.state.file == null || !this.checkForm(this.state.form)}
                                            onClick={() => this.addNewFile()}
                                          >
                                            {Labels.GetLabel("adminstategroup.savebtn")}
                                          </Button>
                                        </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                      </div>
                                      : this.state.isModalVisible == "edit" ?
                                        <div>
                                          <Modal.Header>
                                            <Modal.Title>{Labels.GetLabel("myuser.edit")}</Modal.Title>
                                          </Modal.Header>
                                          <Modal.Body>
                                            <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("title", value)} label={Labels.GetLabel("program_refund.Title")}
                                              onInvalid={(value) => this.updateForm("title", null)} value={this.state.data.invoice.title} />
                                            <div style={{ display: "flex" }}>
                                              <div style={{ flex: 1 }}>
                                                <MaskedInput type="select" data={["NOTA_FISCAL", "CUPOM_FISCAL", "RECIBO_PAPEL"]} parser={t => Labels.GetLabel("invoice_type." + t)} notnull={true} onValid={(value) => this.updateForm("invoiceType", { KeyRegister: value[0] })} label={Labels.GetLabel("program_refund.InvoiceType")}
                                                  onInvalid={(value) => this.updateForm("invoiceType", null)} placeholder={Labels.GetLabel("generic.select")} value={this.state.data.invoice.invoiceType} />
                                              </div>
                                              <div style={{ flex: 1, marginLeft: 10 }}>
                                                <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("indentificator", value)} label={Labels.GetLabel("program_refund.Indentificator")}
                                                  onInvalid={(value) => this.updateForm("indentificator", null)} value={this.state.data.invoice.indentificator} />
                                              </div>
                                            </div>
                                            <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("issuer", value)} label={Labels.GetLabel("program_refund.Issuer")}
                                              onInvalid={(value) => this.updateForm("issuer", null)} value={this.state.data.invoice.issuer} />
                                            <div style={{ display: "flex" }}>
                                              <div style={{ flex: 1 }}>
                                                <MaskedInput type="select" name="keyConstant,label" data={[{ keyConstant: 2, label: "DOC_CNPJ" }, { keyConstant: 1, label: "DOC_CPF" }]} notnull={true} onValid={(value) => this.updateForm("mainKeyCriticalType", { keyConstant: parseInt(value[0]) })} label={Labels.GetLabel("program_refund.MainKeyCriticalType")}
                                                  onInvalid={(value) => this.updateForm("mainKeyCriticalType", null)} placeholder={Labels.GetLabel("generic.select")} parser={(t) => Labels.GetLabel("information." + t)} value={this.state.data.invoice.mainKeyCriticalType} />
                                              </div>
                                              <div style={{ flex: 1, marginLeft: 10 }}>
                                                {
                                                  ((t) => {
                                                    return t == 2 ?
                                                      <MaskedInput key={2} type="cnpj" notnull={true} onValid={(value) => this.updateForm("criticalValue", value)} label={Labels.GetLabel("program_refund.criticalValue")}
                                                        onInvalid={(value) => this.updateForm("criticalValue", null)} value={this.state.data.invoice.criticalValue} /> :
                                                      <MaskedInput key={1} type="cpf" notnull={true} onValid={(value) => this.updateForm("criticalValue", value)} label={Labels.GetLabel("program_refund.criticalValue")}
                                                        onInvalid={(value) => this.updateForm("criticalValue", null)} value={this.state.data.invoice.criticalValue} />
                                                  })(this.state.form.mainKeyCriticalType == null ? 2 : this.state.form.mainKeyCriticalType.keyConstant)
                                                }
                                              </div>
                                            </div>
                                            <div style={{ display: "flex" }}>
                                              <div style={{ flex: 1 }}>
                                                <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("datetimeEmission", this.parseDate(value))} label={Labels.GetLabel("program_refund.DatetimeEmission")}
                                                  onInvalid={(value) => this.updateForm("datetimeEmission", null)} value={Parsers.parseDate(this.state.data.invoice.datetimeEmission, "time")} />
                                              </div>
                                              <div style={{ flex: 1, marginLeft: 10 }}>
                                                <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("series", value)} label={Labels.GetLabel("program_refund.Series")}
                                                  onInvalid={(value) => this.updateForm("series", null)} value={this.state.data.invoice.series} />
                                              </div>
                                            </div>
                                            <MaskedInput type="decimal" notnull={true} onValid={(value) => this.updateForm("valueTotal", Parsers.normalizeNumber(value))} label={Labels.GetLabel("program_refund.ValueTotal")}
                                              onInvalid={(value) => this.updateForm("valueTotal", null)} value={this.state.data.invoice.valueTotal} />
                                            <br />
                                            <MaskedInput type="text" onValid={(value) => this.updateForm("observation", value)} label={Labels.GetLabel("program_refund.Obs")}
                                              onInvalid={(value) => this.updateForm("observation", null)} value={this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant == 1)[0].storageManager.observation} />
                                            <br />
                                            {
                                              this.state.data.qaActionPlan.qualitativeAward.purchasingGoal.program.programPaymentType.keyConstant == 2 ? null :
                                                <div>
                                                  <div style={{ fontWeight: "bold", marginBottom: 20, marginTop: 20 }}>{Labels.GetLabel("program_refund.refundinfo")}</div>
                                                  <div style={{ display: "flex" }}>
                                                    <div style={{ flex: 1 }}>
                                                      <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("accountBank", value)} label={Labels.GetLabel("program_refund.accountBank")}
                                                        onInvalid={(value) => this.updateForm("accountBank", null)} value={this.state.data.invoice.accountBank} />
                                                    </div>
                                                    <div style={{ flex: 1, marginLeft: 10 }}>
                                                      <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("accountAgency", value)} label={Labels.GetLabel("program_refund.accountAgency")}
                                                        onInvalid={(value) => this.updateForm("accountAgency", null)} value={this.state.data.invoice.accountAgency} />
                                                    </div>
                                                  </div>
                                                  <div style={{ display: "flex" }}>
                                                    <div style={{ flex: 1 }}>
                                                      <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("accountNumber", value)} label={Labels.GetLabel("program_refund.accountNumber")}
                                                        onInvalid={(value) => this.updateForm("accountNumber", null)} value={this.state.data.invoice.accountNumber} />
                                                    </div>
                                                    <div style={{ flex: 1, marginLeft: 10 }}>
                                                      <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("accountType", value)} label={Labels.GetLabel("program_refund.accountType")}
                                                        onInvalid={(value) => this.updateForm("accountType", null)} value={this.state.data.invoice.accountType} />
                                                    </div>
                                                  </div>
                                                </div>
                                            }
                                            <br />
                                          </Modal.Body>
                                          <Modal.Footer>
                                            <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                              {Labels.GetLabel("adminstategroup.closebtn")}
                                            </Button>
                                            <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.editInvoice()}>
                                              {Labels.GetLabel("adminstategroup.savebtn")}
                                            </Button>
                                          </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                        </div>

                                        :
                                        this.state.isModalVisible == "changestatus" ?
                                          < div >
                                            <Modal.Header>
                                              <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                              {
                                                this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant != 1 && t.storageInvoiceElType.keyConstant != 5).length >= 2 ? (
                                                  <div>
                                                    {Labels.GetLabel("REFUND_STATUS_PROGRAM_WARNING." + (this.state.nextstatus))}
                                                    <br />
                                                    <br />
                                                    {
                                                      this.state.nextstatus == 9 ?
                                                        <MaskedInput type="text" label={Labels.GetLabel("generic.observation")} notnull={true}
                                                          onValid={(value) => this.updateForm("observation", (value))}
                                                          onInvalid={(value) => this.updateForm("observation", null)} />
                                                        :
                                                        this.state.nextstatus == 12 ?
                                                          <div>
                                                            <MaskedInput type="text" label={Labels.GetLabel("program_refund.disputecase")} notnull={true}
                                                              onValid={(value) => this.updateForm("observation", (value))}
                                                              onInvalid={(value) => this.updateForm("observation", null)} />
                                                            {
                                                              this.state.data.qaActionPlan.qualitativeAward.purchasingGoal.program.programPaymentType.keyConstant != 1 ? null :
                                                                <div>
                                                                  <Form.Label>{Labels.GetLabel("program_refund.receipt")}</Form.Label>
                                                                  <Form.File id="exampleFormControlFile1" onChange={t => this.setState({ file: t.target })} />
                                                                </div>
                                                            }
                                                            <br />
                                                          </div>
                                                          : null
                                                    }
                                                  </div>
                                                ) : Labels.GetLabel("program_refund.filenot2")
                                              }

                                            </Modal.Body>
                                            <Modal.Footer>
                                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                {Labels.GetLabel("adminstategroup.closebtn")}
                                              </Button>
                                              {this.state.data.invoice.storageInvoiceElement.filter(t => t.storageInvoiceElType.keyConstant != 1 && t.storageInvoiceElType.keyConstant != 5).length >= 2 && (
                                                <Button variant="primary"
                                                  disabled={!this.checkForm(this.state.form) || (this.state.nextstatus == 12 && (this.state.data.qaActionPlan.qualitativeAward.purchasingGoal.program.programPaymentType.keyConstant == 1 && this.state.file == null))}
                                                  onClick={() => this.changeStatus()}>
                                                  {Labels.GetLabel("generic.confirm")}
                                                </Button>
                                              )}

                                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                          </div>
                                          :
                                          <div>
                                            <Modal.Header>
                                              <Modal.Title>{Labels.GetLabel("clientsnew.franchiseeHeader")}</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                              {Labels.GetLabel("clientsnew.confirmation")}
                                            </Modal.Body>
                                            <Modal.Footer>
                                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                {Labels.GetLabel("adminstategroup.closebtn")}
                                              </Button>
                                              <Button variant="primary" onClick={() => this.addNew()}>
                                                {Labels.GetLabel("adminstategroup.savebtn")}
                                              </Button>
                                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                          </div>
                    }
                  </div>
                </Modal>
              </div>
        }
      </Container >
    );
  }
} 